// extracted by mini-css-extract-plugin
export default {"tupacGrid":"vl-z","tupacHeader":"wl-z","tupacHeader2":"xl-z","tupacMenu":"yl-z","tupacMenu2":"zl-z","tupacMain":"Al-z","tupacMain2":"Bl-z"};